import { Suspense } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Widget } from 'src/dashboard/Componets/Widget';
import { AreaChartSkeleton } from 'src/common/components/Graphs/common/Graphs/components/AreaChartSkeleton';
import { RSimPerformanceChartWidget } from './RSimPerformanceChartWidget';
import { RSimActiveStateWidget } from './RSimActiveStateWidget';
import { RSimUsageChartWidget } from './RSimUsageChartWidget';
import { Carusel, CaruselItem } from 'src/common/components/Carusel/Carusel';
import { useGraphsWidgetsWidths } from './hooks/useGraphsWidgetsWidths';
import { RSimSubscriptionStateChartWidget } from './RSimSubscriptionStateChartWidget';

const AreaChartSkeletonContainer = styled(Box)(({ theme }) => ({
  height: `calc(100% - ${theme.spacing(20)})`,
}));

export const RSimGraphs = () => {
  const { t } = useTranslation();

  const { subscriptionStatusWidth, statusWidth, performanceWidth, usageWidth } =
    useGraphsWidgetsWidths();

  return (
    <Carusel>
      <CaruselItem width={subscriptionStatusWidth} data-testid="rSimubscriptionStatus">
        <RSimSubscriptionStateChartWidget />
      </CaruselItem>

      <CaruselItem width={statusWidth} data-testid="rSimStatus">
        <RSimActiveStateWidget />
      </CaruselItem>

      <CaruselItem width={performanceWidth} data-testid="performanceChart">
        <Suspense
          fallback={
            <Widget title={t('dashboard.cumulativeUsageChart.title')}>
              <AreaChartSkeletonContainer>
                <AreaChartSkeleton />
              </AreaChartSkeletonContainer>
            </Widget>
          }
        >
          <RSimPerformanceChartWidget />
        </Suspense>
      </CaruselItem>

      <CaruselItem width={usageWidth} data-testid="rsimUsageChart">
        <Suspense
          fallback={
            <Widget title={t('dashboard.cumulativeUsageChart.title')}>
              <AreaChartSkeletonContainer>
                <AreaChartSkeleton />
              </AreaChartSkeletonContainer>
            </Widget>
          }
        >
          <RSimUsageChartWidget />
        </Suspense>
      </CaruselItem>
    </Carusel>
  );
};
